import { useMemo } from 'react';

import { JobPositionForCandidateDto } from '@pflegia/data-access';
import { JOB_DETAILS } from '@pflegia/ui/pflegia/constants/routes';
import { getJobPositionPathname } from '@pflegia/util/functions/job-position/helpers';

interface JobPositionListJsonLdProps {
  city?: string;
  jobs?: JobPositionForCandidateDto[];
}

const JobPositionListJsonLd: React.FC<JobPositionListJsonLdProps> = ({ city, jobs }) => {
  const jsonLd = useMemo(
    () =>
      jobs?.length
        ? {
            '@context': 'https://schema.org',
            '@type': 'ItemList',
            name: city ? `Jobs in ${city}` : 'Jobs',
            url: window.location.href,
            numberOfItems: jobs.length,
            itemListElement: jobs.map(({ jobPosition: job }, index) => ({
              '@type': 'ListItem',
              position: index + 1,
              name: job.title,
              url: new URL(getJobPositionPathname(job, { basePath: JOB_DETAILS }), window.location.href).toString(),
            })),
          }
        : null,
    [city, jobs],
  );

  return jsonLd ? <script type='application/ld+json' dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} /> : null;
};

export default JobPositionListJsonLd;
